<template>
  <b-dropdown
    size="sm"
    variant="link"
    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
    no-caret
    right
    no-flip
  >
    <template v-slot:button-content>
      <slot></slot>
    </template>
    <!--begin::Navigation-->
    <div class="navi navi-hover">
      <b-dropdown-text tag="div" class="p-1 border-bottom navi-header font-weight-bold">
        <span class="h5">
          Choose Label:
        </span>
        <i
          class="flaticon2-information icon-md text-muted"
          v-b-tooltip="'Click to learn more...'"
        ></i>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item m-1">
        <a class="navi-link btn-sm btn-success d-inline-block">Customer</a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item m-1">
        <a class="navi-link btn-sm btn-danger d-inline-block">Partner</a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item m-1">
        <a class="navi-link btn-sm btn-warning d-inline-block">Suplier</a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item m-1">
        <a class="navi-link btn-sm btn-primary d-inline-block">Member</a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item m-1">
        <a class="navi-link btn-sm btn-dark d-inline-block">Staff</a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-footer border-top p-1">
        <a class="font-weight-bold   d-flex align-items-center text-muted">
          <i class="bx bx-plus mr-1"></i>Add new</a
        >
      </b-dropdown-text>
    </div>
    <!--end::Navigation-->
  </b-dropdown>
</template>

<style lang="scss">
.navi{
  min-width: 250px;
}
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
export default {
  name: "dropdown-2",
  components: {},
  mounted() {}
};
</script>
